import Crud from "../helpers/crud";

const crud = new Crud("residential-building");

export default {
    namespaced: true,

    state() {
        return {
            ...crud.state,

            options: null
        }
    },

    actions: {
        ...crud.actions,
    },

    mutations: {
        ...crud.mutations,
    },

    getters: {
        ...crud.getters,
    }
}